import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const CHART = ["#0F3F2D", "#2F7A57", "#7FB89B", "#C7A24A", "#52525B", "#94A3B8", "#B7CBBF"];

export const money = (n) =>
  n >= 1000000 ? `$${(n / 1000000).toFixed(2)}M` : `$${Number(n).toLocaleString()}`;

export async function streamAsk(message, sessionId, onDelta, onDone) {
  const res = await fetch(`${API}/ask-scratch`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, session_id: sessionId }),
  });
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (!line.startsWith("data:")) continue;
      try {
        const obj = JSON.parse(line.slice(5).trim());
        if (obj.delta) onDelta(obj.delta);
        if (obj.done && onDone) onDone();
      } catch (e) {}
    }
  }
  if (onDone) onDone();
}
